import api from "../index";

export default {
    /**
     * Get
     * @param params
     */
    get(params) {
        return api
            .get(`/billing/quotes`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Show
     * @param quote
     * @param params
     */
    show(quote, params) {
        return api
            .get(`/billing/quotes/${quote}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update
     * @param quote
     * @param data
     */
    update(quote, data) {
        return api.put(`/billing/quotes/${quote}`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Update dates
     * @param quote
     * @param data
     */
    updateDates(quote, data) {
        return api.post(`/billing/quotes/${quote}/update-dates`, data).then((response) => {
            return response.data;
        });
    },
    /**
     * Delete
     * @param quote
     */
    delete(quote) {
        return api.delete(`/billing/quotes/${quote}`).then((response) => {
            return response.data;
        });
    },

    /**
     * Finalize
     * @param quote
     */
    finalize(quote) {
        return api
            .post(`/billing/quotes/${quote}/finalize`)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get invoice
     * @param quote
     * @param params
     */
    getInvoice(quote, params) {
        return api
            .get(`/billing/quotes/${quote}/invoice`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Cancel
     * @param quote
     */
    cancel(quote) {
        return api.post(`/billing/quotes/${quote}/cancel`).then((response) => {
            return response.data;
        });
    },

    /**
     * Accept
     * @param quote
     */
    accept(quote) {
        return api.post(`/billing/quotes/${quote}/accept`).then((response) => {
            return response.data;
        });
    },

    /**
     * Process
     * @param quote
     */
    process(quote) {
        return api.post(`/billing/quotes/${quote}/process`).then((response) => {
            return response.data;
        });
    },

    /**
     * Force process
     * @param quote
     */
    forceProcess(quote) {
        return api
            .post(`/billing/quotes/${quote}/force-process`)
            .then((response) => {
                return response.data;
            });
    },
    /**
     * Unprocess
     * @param quote
     */
    unprocess(quote, data) {
        return api
            .post(`/billing/quotes/${quote}/unprocess`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Create
     * @param data
     */
    create(data) {
        return api.post(`/billing/quotes`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Add line
     * @param data
     */
    addLine(data) {
        return api
            .post(`/billing/quotes/${quote}/lines`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update line
     * @param line
     * @param data
     */
    updateLine(line, data) {
        return api
            .put(`/billing/quote-lines/${line}`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update line
     * @param quoteLineId
     * @param params
     */
    showLine(quoteLineId, params) {
        return api
            .get(`/billing/quote-lines/${quoteLineId}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Delete line
     * @param line
     */
    deleteLine(line) {
        return api.delete(`/billing/quote-lines/${line}`).then((response) => {
            return response.data;
        });
    },

    /**
     * Get lines
     * @param quote
     * @param params
     */
    getLines(quote, params) {
        return api
            .get(`/billing/quotes/${quote}/lines`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get grouped lines
     * @param quote
     * @param params
     */
    getGroupedLines(quote, params) {
        return api
            .get(`/billing/quotes/${quote}/lines/grouped`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },
};
